import { render, staticRenderFns } from "./pTree.vue?vue&type=template&id=6a379879&"
import script from "./pTree.vue?vue&type=script&lang=js&"
export * from "./pTree.vue?vue&type=script&lang=js&"
import style0 from "./pTree.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports